export enum WipActionType {
  ClearPageKey = 'wip/CLEAR_PAGE_KEY',
  SetPageKey = 'wip/SET_PAGE_KEY',
}
